var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"jdsc-reaction-option",attrs:{"aria-selected":_vm.active},on:{"click":_vm.emitClick}},[_vm._v(" "+_vm._s(_vm.type)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }